module.exports = __webpack_public_path__ + "media/images/lane/icon_map-49ad1a580692d172c09a2858f69ff25f.svg";